var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCampaignDashboardIconActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.867 5.679a.25.25 0 0 0-.386-.039l-4.713 4.714a.5.5 0 0 1-.706-.707l5.794-5.793a.5.5 0 1 0-.707-.708l-.836.837a7.003 7.003 0 0 0-10.917 7.845 1.01 1.01 0 0 0 .945.672h11.317a1 1 0 0 0 .944-.67 7.02 7.02 0 0 0-.735-6.151M3.59 10.4a.5.5 0 0 1-.98.198 5.504 5.504 0 0 1 6.364-6.513.5.5 0 1 1-.176.985A4.504 4.504 0 0 0 3.59 10.4"
})));
export { SvgCampaignDashboardIconActive as ReactComponent };
export default __webpack_public_path__ + "bdd07e02fb1771b0f240a39ad5c850a2.svg";